document.addEventListener('DOMContentLoaded', function () {
  // ---------- header scroll state ----------
  var header = document.getElementById('lisseHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ---------- mobile menu ----------
  var burger = document.getElementById('lisseBurger');
  var mobileMenu = document.getElementById('lisseMobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('open'); });
    });
  }

  // ---------- dark mode ----------
  var modeToggle = document.getElementById('lisseModeToggle');
  if (modeToggle) {
    modeToggle.addEventListener('click', function () {
      document.documentElement.classList.toggle('dark');
    });
  }

  // ---------- scroll reveal ----------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: .15 });
    document.querySelectorAll('.reveal,.reveal-stagger').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal,.reveal-stagger').forEach(function (el) { el.classList.add('in'); });
  }

  // ---------- FAQ accordion ----------
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        if (o !== item) {
          o.classList.remove('open');
          o.querySelector('.faq-a').style.maxHeight = null;
          o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('open');
      q.setAttribute('aria-expanded', String(!isOpen));
      a.style.maxHeight = !isOpen ? a.scrollHeight + 'px' : null;
    });
  });

  // ---------- before/after slider: spray-mist reveal ----------
  (function () {
    var wrap = document.getElementById('lisseCompareWrap');
    if (!wrap) return;
    var range = document.getElementById('lisseCompareRange');
    var beforeWrap = document.getElementById('lisseBeforeWrap');
    var mistGlow = document.getElementById('lisseMistGlow');
    var canvas = document.getElementById('lisseSprayCanvas');
    var ctx = canvas ? canvas.getContext('2d') : null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var cssW = 0, cssH = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var target = 50, current = 50, running = true;

    function resize() {
      var rect = wrap.getBoundingClientRect();
      cssW = rect.width; cssH = rect.height;
      if (canvas) {
        canvas.width = cssW * dpr; canvas.height = cssH * dpr;
        canvas.style.width = cssW + 'px'; canvas.style.height = cssH + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
    }
    window.addEventListener('resize', resize);
    resize();

    var AMBIENT_COUNT = 46;
    var ambient = Array.from({ length: AMBIENT_COUNT }, function () {
      return {
        relY: Math.random(),
        jitterX: (Math.random() - 0.5) * 70,
        r: 0.6 + Math.random() * 1.8,
        phase: Math.random() * Math.PI * 2,
        speed: 0.4 + Math.random() * 0.6,
        baseAlpha: 0.18 + Math.random() * 0.4
      };
    });

    var bursts = [];
    function spawnBurst(px) {
      if (reduceMotion) return;
      var n = 3 + Math.floor(Math.random() * 3);
      for (var i = 0; i < n; i++) {
        bursts.push({
          x: px + (Math.random() - 0.5) * 14,
          y: Math.random() * cssH,
          r: 1 + Math.random() * 2.2,
          vx: (Math.random() - 0.5) * 0.6,
          vy: (Math.random() - 0.5) * 0.6,
          life: 1,
          decay: 0.02 + Math.random() * 0.02
        });
      }
      if (bursts.length > 140) bursts = bursts.slice(-140);
    }

    var lastBurstT = 0;
    function applyValue(v, userDriven) {
      v = Math.max(0, Math.min(100, v));
      if (range) range.value = v;
      target = v;
      if (userDriven) {
        var now = performance.now();
        if (now - lastBurstT > 45) { spawnBurst((v / 100) * cssW); lastBurstT = now; }
      }
    }
    function valueFromClientX(clientX) {
      var rect = wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var dragging = false;
    wrap.addEventListener('pointerdown', function (e) {
      dragging = true;
      wrap.setPointerCapture(e.pointerId);
      applyValue(valueFromClientX(e.clientX), true);
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      applyValue(valueFromClientX(e.clientX), true);
    });
    wrap.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('pointercancel', function () { dragging = false; });

    if (range) {
      range.addEventListener('input', function (e) { applyValue(+e.target.value, true); });
    }

    function draw(t) {
      if (!ctx) return;
      ctx.clearRect(0, 0, cssW, cssH);
      var px = (current / 100) * cssW;

      for (var i = 0; i < ambient.length; i++) {
        var p = ambient[i];
        var x = px + p.jitterX + Math.sin(t * 0.001 * p.speed + p.phase) * 4;
        var y = p.relY * cssH + Math.sin(t * 0.0006 * p.speed + p.phase) * 6;
        var alpha = p.baseAlpha * (0.6 + 0.4 * Math.sin(t * 0.0012 * p.speed + p.phase));
        var grad = ctx.createRadialGradient(x, y, 0, x, y, p.r * 3);
        grad.addColorStop(0, 'rgba(255,255,255,' + alpha + ')');
        grad.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(x, y, p.r * 3, 0, Math.PI * 2);
        ctx.fill();
      }

      bursts.forEach(function (b) { b.x += b.vx; b.y += b.vy; b.life -= b.decay; });
      bursts = bursts.filter(function (b) { return b.life > 0; });
      for (var j = 0; j < bursts.length; j++) {
        var b2 = bursts[j];
        var alpha2 = Math.max(0, b2.life) * 0.55;
        var grad2 = ctx.createRadialGradient(b2.x, b2.y, 0, b2.x, b2.y, b2.r * 2.6);
        grad2.addColorStop(0, 'rgba(255,255,255,' + alpha2 + ')');
        grad2.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = grad2;
        ctx.beginPath();
        ctx.arc(b2.x, b2.y, b2.r * 2.6, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function loop(t) {
      current += (target - current) * (reduceMotion ? 1 : 0.16);
      if (Math.abs(target - current) < 0.05) current = target;
      if (beforeWrap) beforeWrap.style.clipPath = 'inset(0 ' + (100 - current) + '% 0 0)';
      if (mistGlow) mistGlow.style.transform = 'translateX(' + ((current / 100) * cssW - 75) + 'px)';
      draw(t || 0);
      if (running) requestAnimationFrame(loop);
    }

    document.addEventListener('visibilitychange', function () {
      running = document.visibilityState === 'visible';
      if (running) requestAnimationFrame(loop);
    });

    if (beforeWrap) beforeWrap.style.clipPath = 'inset(0 50% 0 0)';
    if (mistGlow) mistGlow.style.transform = 'translateX(' + (cssW * 0.5 - 75) + 'px)';
    requestAnimationFrame(loop);
  })();

  // ---------- ambient dust motes behind the hero product ----------
  function initDust(stage, reduceMotion) {
    var canvas = stage.querySelector('.cine-dust');
    if (!canvas || reduceMotion) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, raf;

    function resize() {
      var r = stage.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    window.addEventListener('resize', resize);
    resize();

    var N = 16;
    var parts = Array.from({ length: N }, function () {
      return {
        x: Math.random() * w, y: Math.random() * h,
        r: 0.6 + Math.random() * 1.5,
        vy: -(0.05 + Math.random() * 0.1),
        vx: (Math.random() - 0.5) * 0.04,
        a: 0.06 + Math.random() * 0.18,
        phase: Math.random() * Math.PI * 2
      };
    });

    function tick(t) {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y += p.vy;
        p.x += p.vx + Math.sin(t * 0.0003 + p.phase) * 0.03;
        if (p.y < -8) { p.y = h + 8; p.x = Math.random() * w; }
        var grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3);
        grad.addColorStop(0, 'rgba(255,252,245,' + p.a + ')');
        grad.addColorStop(1, 'rgba(255,252,245,0)');
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 3, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { raf = requestAnimationFrame(tick); }
      else cancelAnimationFrame(raf);
    });
  }

  // ---------- hero scene: statique, aucune animation ----------
  (function () {
    var stage = document.getElementById('lisseCineStage');
    if (!stage) return;
    // Le cadre du héro reste parfaitement immobile : aucune animation d'entrée,
    // aucun zoom, rotation, poussière ou reflet animé.
    stage.style.opacity = 1;
  })();
});